export default class LegalNav {
    constructor(lenis) {
        this.lenis = lenis;
        this.sidebar = document.querySelector(".no-legal__sidebar");
        this.navLinks = document.querySelectorAll(".no-legal__nav-link");
        this.sections = document.querySelectorAll(".no-legal__section[id]");

        if (!this.sidebar || !this.navLinks.length) {
            console.warn("[LegalNav] Sidebar or nav links not found");
            return;
        }

        this.init();
    }

    init() {
        console.log("[LegalNav] init()");
        this.bindEvents();
        this.observeSections();
    }

    bindEvents() {
        this.navLinks.forEach((link) => {
            link.addEventListener("click", (e) => {
                e.preventDefault();
                const targetId = link.getAttribute("href").substring(1);
                const targetSection = document.getElementById(targetId);

                if (targetSection) {
                    this.scrollToSection(targetSection);
                }
            });
        });
    }

    scrollToSection(section) {
        const headerHeight =
            parseFloat(
                getComputedStyle(document.documentElement).getPropertyValue(
                    "--header-height"
                )
            ) || 80;

        const sectionTop = section.getBoundingClientRect().top + window.scrollY;
        const offset = sectionTop - headerHeight - 40; // 추가 여백 40px

        if (this.lenis) {
            this.lenis.scrollTo(offset, {
                duration: 1.2,
                easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            });
        } else {
            window.scrollTo({
                top: offset,
                behavior: "smooth",
            });
        }
    }

    observeSections() {
        if (!this.sections.length) return;

        const observerOptions = {
            root: null,
            rootMargin: "-20% 0px -70% 0px",
            threshold: 0,
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const id = entry.target.getAttribute("id");
                    this.setActiveLink(id);
                }
            });
        }, observerOptions);

        this.sections.forEach((section) => {
            observer.observe(section);
        });
    }

    setActiveLink(sectionId) {
        this.navLinks.forEach((link) => {
            const linkTarget = link.getAttribute("href").substring(1);
            if (linkTarget === sectionId) {
                link.classList.add("active");
            } else {
                link.classList.remove("active");
            }
        });
    }
}
